import React from "react"
import { Typography, makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  disclaimerContent: {
    lineHeight: 1.6,
    color: theme.palette.primary.main,
  },
}))

const Disclaimer = () => {
  const classes = useStyles()

  return (
    <div className={classes.disclaimerContent}>
      <Typography variant="body1" paragraph>
        Users should review the accuracy and completeness of all output generated though the Tool. Users should not enter any unnecessary personal information or any sensitive personal data, client confidential information, state secrets, commercial secrets, or anything that would violate professional secrecy or confidentiality rules or that would be considered abusive/irrelevant.
      </Typography>
      <Typography variant="body1">
        EY does not intentionally collect any sensitive personal data from you via the Tool. The Tool's intention is not to process such information. Accordingly, you should not enter any unnecessary personal information or any sensitive personal data (including government identifiers such as tax file numbers or social security numbers/national identification numbers), client confidential information (except client entity names), audit secrets, state secrets, trade secrets, or anything that would violate professional secrecy or confidentiality rules or that would be considered abusive/irrelevant in the Tool.
      </Typography>
    </div>
  )
}

export default Disclaimer